export const useApiIdError = (apiPath: string) => {
  const readableApiPath = apiPath.replace(/-/g, ' ');

  return new Error(`Invalid id to fetch ${readableApiPath}`);
};
